import Environment from "../Environment/Environment";
import Token from "../Token/Token";

class Url {

  protected backendEndpoint: string = Environment.getBackendEndpoint();
  protected frontendEndpoint: string = Environment.getFrontendEndpoint();
  protected prefix: string = "api/v1";

  public to(path: string, isBackend: boolean = true): string {
    if (isBackend === true) {
      return `${this.getBackendEndpoint()}/${this.prefix}/${path}`;
    }

    return `${this.getFrontendEndpoint()}/${path}`;
  }

  public getAttachment(path: string, filename: string = null) {
    // @todo second parameter fileName: string = null. if fileName, send fileName, else urlFilename
    const urlFilename = (path || "").substring((path || "").lastIndexOf('/') + 1);
    const url = `${this.getBackendEndpoint()}/${this.prefix}/attachment/download/${filename ? encodeURIComponent(filename) : urlFilename}?url=${encodeURIComponent(path)}&token=${Token.getInstant()}`;

    return url;
  }

  public getBackendEndpoint(): string {
    return this.backendEndpoint;
  }

  public getFrontendEndpoint(): string {
    return this.frontendEndpoint;
  }
}

export default new Url();
